import { chartIconGrey, chartIconPurple, tableIconGrey, tableIconPurple } from '../../assets/hostedassets';

export const DASHBOARD_DATA_TYPES = {
    CHARTS: 'CHARTS',
    TABLE: 'TABLE',
};

export const dataTypeSelectorOptions = [
    {
        id: DASHBOARD_DATA_TYPES.TABLE,
        icon: tableIconGrey,
        iconSelected: tableIconPurple,
        label: 'Table',
    },
    {
        id: DASHBOARD_DATA_TYPES.CHARTS,
        icon: chartIconGrey,
        iconSelected: chartIconPurple,
        label: 'Chart',
    },
];

// GST Revenue/Expense view when ?dataType is absent; not the parent Dashboard default, which stays CHARTS.
export const resolveGstAnalysisDataType = (dataTypeQuery: string | null) => dataTypeQuery || DASHBOARD_DATA_TYPES.TABLE;

export const PRESELECT_ALL_REFRESH_MODULES_QUERY = 'preselectAllRefreshModules';

export const GST_LAST_CONSENT_LABEL = 'Last consent: ';
